<template>

    <b-table :data="uploadDates" ref="table" :mobile-cards="false" hoverable striped bordered
             v-bind="$attrs" v-on="$listeners" sticky-header height="80vh" class="upload-requests-table">
        <template #empty>
            <b><slot name="empty-message">No requests found</slot></b>
        </template>
        <template #bottom-left>
            <b>Upload requests:</b>
        </template>

        <b-table-column field="date" label="Date"
                        cell-class="fix-sticky-z-index"
                        width="60" sticky class="upload-requests-table-date-column">
            <template v-slot:header="{ column }">
                <div class="date-header">
                    <b>{{ column.label }}</b>
                    <br>
                </div>
            </template>

            <template v-slot="props">
                <span :title="props.row">{{ new Date(props.row) | moment("D.MM.YYYY") }}</span>
            </template>

        </b-table-column>

            <template v-for="targetBuild in targetBuilds">
                <b-table-column :label="targetBuild.target"
                                :custom-key="targetBuild.id"
                                :key="targetBuild.id"
                                style="width: 20vh;">
                    <template v-slot:header="{ column }">
                        <div class="upload-requests-table-target-build-header">
                            <div class="tooltip-target target-build-header" :title="targetBuild.target">
                                <span class="test-run-id">{{ column.label }}</span>
                                <span class="target-build-time">{{ new Date(targetBuild.started_at) | moment("D.MM.YYYY HH:mm") }}</span>
                                <span v-if="targetBuild.filesystem" class="target-build-time"> FS: <b> {{ targetBuild.filesystem }} </b></span>
                            </div>
                            <div class="container target-build-footer">
                              <div class="level">
                                <button class="delete delete-target-build-button"
                                        @click="$emit('delete-target-build', targetBuild.id)"/>
                              </div>
                            </div>
                        </div>
                    </template>
                    <template v-slot="props">
                        <div class="request-result-container">
                            <div @click="onSelectUploadRequestResults(props.row, targetBuild.id)">
                              <upload-requests-count
                                  :upload-requests="getUploadRequestsCount(props.row, targetBuild.id)"/>
                            </div>
                        </div>
                    </template>
                </b-table-column>
            </template>

    </b-table>
</template>

<script>
    import UploadRequestsCount from "@/components/UploadRequestResultsForTarget.vue";

    export default {
        name: "UploadRequestResultsTable",
        props: {
            uploadRequests: Array,
            uploadDates: Array,
            targetBuilds: Array,
        },
        data() {
            return {
                currentTestResult: null,
                isTestResultModalActive: false,
            }
        },
        methods: {
            getUploadRequestsCount(date, targetBuildId) {
                return this.uploadRequests.filter(item => {
                    const requestDate = new Date(item.started_at)
                    requestDate.setHours(0, 0,0 , 0)
                    return requestDate.getTime() === (new Date(date)).getTime() && item.target_id === targetBuildId;});
            },
            onSelectUploadRequestResults(requestsDate, targetBuildId) {
                this.$emit('select-upload-request-results', { requestsDate, targetBuildId });
            },
        },
        components: {
            UploadRequestsCount,
        },
    }
</script>

<style lang="scss" scoped>
    .upload-requests-table-date-column {
        max-width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .test-run-id {
        font-weight: bold;
        cursor: pointer;
        font-size: 0.75em;
        &:hover {
            text-decoration: underline;
        }
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
    }

    .request-result-container {
        &:hover, &:focus, &:active {
            background-color: $grey-lightest;
        }
        & > div {
            display: flex;
            align-items: start;
            justify-content: start;
            /*flex-wrap: wrap;*/
            flex-direction: row;
        }
    }

    .upload-requests-table {
        margin-bottom: 5px;
    }

    .upload-requests-table-target-build-header {
        display: flex;
        flex-direction: column;
        width: 6vw;
    }

    .date-header {
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    .target-build-header {
        display: flex;
        flex-direction: column;
        margin: 0.75em 0;
    }

    .target-build-footer {
        height: 24px;
        padding: 0;
        line-height: 1;
        width: 100%;
    }

    .target-build-time {
        font-size: 0.65em;
        color: $grey;
        font-weight: normal;
    }

    .delete-target-build-button {
        opacity: 0;
        transition: opacity .15s ease;
    }

    th:hover .delete-target-build-button {
        opacity: 1;
    }
</style>